import { render, staticRenderFns } from "./ViewCollectionEvent.vue?vue&type=template&id=b712c492"
import script from "./ViewCollectionEvent.vue?vue&type=script&lang=js"
export * from "./ViewCollectionEvent.vue?vue&type=script&lang=js"
import style0 from "./ViewCollectionEvent.vue?vue&type=style&index=0&id=b712c492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports